export default __webpack_public_path__ + "static/media/bg-banner.a690c1cb.jpg";